import { apiSlice } from '../api/apiSlice';

export const transportVehicleApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTransportVehiclesByShopId: builder.query({
      query: (shopid) => ({
        url: '/tranportvehicle/',
        params: { shopid },
      }),
      providesTags: (result, error, shopid) => [
        { type: 'TransportVehicle', id: 'LIST' },
        { type: 'TransportVehicle', id: shopid },
      ],
    }),
    getTransportVehicleById: builder.query({
      query: (id) => ({
        url: '/tranportvehicle/id/',
        params: { id },
      }),
      providesTags: (result, error, id) => [{ type: 'TransportVehicle', id }],
    }),
    deleteTransportVehicle: builder.mutation({
      query: (id) => ({
        url: '/tranportvehicle/',
        method: 'DELETE',
        params: { id },
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'TransportVehicle', id },
        { type: 'TransportVehicle', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useGetTransportVehiclesByShopIdQuery,
  useGetTransportVehicleByIdQuery,
  useDeleteTransportVehicleMutation,
} = transportVehicleApiSlice;
